/**
 * author: Soumya Shreyas
 */
import { useEffect, useState } from "react";
import { Collapse, Dropdown, Modal, OverlayTrigger } from "react-bootstrap";
import { useTranslation, withTranslation } from "react-i18next";
import {
  BiChevronDown,
  BiDotsHorizontalRounded,
  BiGitMerge,
  BiPencil,
  BiPlus,
  BiTrash,
  BiGridVertical,
} from "react-icons/bi";
import Utils from "../../../../core/utilities/Utils";

import StandardService from "../../../../core/service/StandardService";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CategoryType, LS_CATEGORY_NAME_KEY } from "../../../../core/constants/common";
import useHasPermission from "../../../../core/hooks/useHasPermission";
import CommonService from "../../../../core/service/CommonService";
import GeneralDisclosureService from "../../../../core/service/GeneralDisclosureService";
import ConfirmDialog from '../../../../core/utilities/ConfirmPopup';
import PermissionUtils from "../../../../core/utilities/PermissisonUtils";
import GDQuestionFormPopup from "../../Disclosures/GDQuestionFormPopup";
import AddTopic from "../AddTopic/AddTopic";
import "./Topics.scss";
function Topics({
  t,
  std_id,
  isFinalizeInProgress = false,
  selectedTopicIds = [],
  onSelectedTopicIdsChange,
  refreshKey = 0,
}) {
  const [show, setShow] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [messageConfirmation, setMessageConfirmation] = useState("");
  const [confirmId, setConfirmId] = useState("");
  let lsData = JSON.parse(localStorage.getItem("authority"));
  const [socialtabledata, setSocialTableData] = useState([]);
  const [environmenttabledata, setEnvironmentTableData] = useState([]);
  const [governancetabledata, setGovernanceTableData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [dsList, setDsList] = useState([]);
  const [shown, setShown] = useState(false);
  const [currentDs, setCurrentDs] = useState([]);
  const [data, setData] = useState([]);
  const categoryType = '';
  const navigate = useNavigate();
  const [editTopicId, setEditTopicId] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [editedQuestion, setEditedQuestion] = useState(null);
  const [gri1TableData, setGRI1TableData] = useState([]);
  const [gri2TableData, setGRI2TableData] = useState([]);
  const [gri3TableData, setGRI3TableData] = useState([]);
  const [brsrTableData, setBRSRTableData] = useState([]);
  const [draggedTopic, setDraggedTopic] = useState(null);
  const [dragOverTopicId, setDragOverTopicId] = useState(null);
  const [dragOverCategory, setDragOverCategory] = useState(null);
  const [isDragHandleActive, setIsDragHandleActive] = useState(false);
  const { k, i18n } = useTranslation();
  const { hasConfigUpdatePermission } = useHasPermission();
  useEffect(() => {
    const lsCategory = localStorage.getItem(LS_CATEGORY_NAME_KEY);
    if (lsCategory != null && lsCategory != undefined && lsCategory != '') {
      handleExpand(lsCategory);
    }
    getCategory();
    getTopics(std_id);
  }, [std_id, refreshKey]);

  const getTopics = (stdid) => {
    StandardService.getTopics(stdid)
      .then((response) => {
        // setList(response?.data);
        const topics = response?.data?.topics;
        filterCategoryData(topics);
        if (Array.isArray(topics)) {
          setData([...topics]);
        } else {
          setData([]);
        }

      })
      .catch((error) => { });
  };

  const handleExpandDs = (e, categoryType) => {
    setDsList([]);
    setCurrentDs([]);
    //setSelDataSource(id);

    const newVal = !shown[categoryType];
    if (newVal) {
      let obj = { categoryType: categoryType };
      setCurrentDs([...currentDs, obj]);
    }
    setShown({
      [categoryType]: !shown[categoryType],
    });

    //  setIsExpanded(true);
  };

  const getCategory = async (e) => {
    StandardService.getCategory(std_id)
      .then((response) => {
        if (response.status !== 200) return;
        // translateCategory([...response.data]);
        setCategoryData([...response.data]);
      })
      .catch((error) => { });
  };


  const filterCategoryData = (datas) => {
    const sortByOrder = (arr) => [...arr].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
    setSocialTableData(sortByOrder(datas.filter(x => x.categoryType === "SOCIAL")));
    setEnvironmentTableData(sortByOrder(datas.filter(x => x.categoryType === "ENVIRONMENTAL")));
    setGovernanceTableData(sortByOrder(datas.filter(x => x.categoryType === "GOVERNANCE")));
  }

  const getTableData = (item) => {
    const updatedData = CommonService.changeFieldNameByi18n(getTableGrouped(item), i18n.language);
    return updatedData;
  }

  const getTableGrouped = (item) => {
    switch (item.categoryType) {
      case 'SOCIAL': return socialtabledata;
      case 'ENVIRONMENTAL': return environmenttabledata;
      case 'GOVERNANCE': return governancetabledata;
      case CategoryType.GRI_1: return gri1TableData;
      case CategoryType.GRI_2: return gri2TableData;
      case CategoryType.GRI_3: return gri3TableData;
      case 'BRSR': return brsrTableData;
      default:
        break;
    }
  }


  const gotoMetric = (name, id, category) => {
    localStorage.setItem('categoryName', category);
    localStorage.setItem('topicName', name);
    let url = '';
    // if (PermissionUtils.isCompanyAdmin(lsData.roles) || PermissionUtils.isConsultant(lsData.roles)) {
    //   url = '/company_admin/metriclist/' + std_id + '/' + id;
    // } else {
    //   url = '/admin/metriclist/' + std_id + '/' + id;
    // }
    if (PermissionUtils.isSuperAdmin(lsData.roles)) {
      url = '/admin/metriclist/' + std_id + '/' + id;
    } else {
      url = '/company_admin/metriclist/' + std_id + '/' + id;
    }
    navigate(url);
  };
  const deleteTopic = (item) => {
    setConfirmId(1);
    setConfirmOpen(true);
    setDeleteId(item.id);

  };

  const deletConfirm = () => {
    StandardService.deleteTopic(std_id, deleteId)
      .then((response) => {
        if (response.status === 204) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          getTopics(std_id);
        }
      })
      .catch((error) => { });
  };


  const editTopic = (item) => {
    setEditTopicId(item.id);
    handleShow(item.categoryType);
  };

  const handleClose = () => setShow(false);
  const handleShow = (category) => {
    localStorage.setItem('categoryName', category);
    setShow(true)
  };
  const handleAfterSave = () => {
    getTopics(std_id);
    handleClose();
  };

  const handleExpand = (id) => {
    if (isUniversalStandardCategory(id) && (!shown || !shown[id] || shown[id] === false)) {
      loadDisclosureQuestions(id);
    }
    const newVal = !shown[id];
    let obj = function (shown) {
      Object.keys(shown).forEach(function (key) {
        shown[key] = false;
      });
      return shown;
    };
    setShown({
      ...obj,
      [id]: newVal,
    });
  }

  const getCategoryName = (category) => {
    if (category.categoryType === CategoryType.GRI_1) {
      return 'GRI 1: Foundation';
    } else if (category.categoryType === CategoryType.GRI_3) {
      return 'GRI 3: Material Topics';
    } else if (category.categoryType === CategoryType.GRI_2) {
      return category.disclosure?.name ?? 'GRI 2: General Disclosures';
    } else {
      switch (category.categoryType) {
        case 'SOCIAL': return t("Social.label");
        case 'ENVIRONMENTAL': return t("Environmental.label");
        case 'GOVERNANCE': return t("Governance.label");
        default:
          break;
      }
    }
  };

  const getCategoryCount = (category) => {
    if (isUniversalStandardCategory(category.categoryType)) {
      return category.disclosure?.questionCount ?? 0;
    } else {
      return category.topicCount ? category.topicCount : 0;
    }
  };

  const loadDisclosureQuestions = (cat) => {
    const disclosure = categoryData.find(c => c.categoryType === cat)?.disclosure;
    if (!disclosure) return;

    GeneralDisclosureService.getAllQuestions(disclosure.id, cat)
      .then((response) => {
        if (response.status !== 200) return;

        const questions = response.data.data?.filter(q => q.parent === null)
          ?.sort((a, b) => a.sortOrder - b.sortOrder);
        if (cat === CategoryType.GRI_1) {
          setGRI1TableData(questions);
        } else if (cat === CategoryType.GRI_3) {
          setGRI3TableData(questions);
        } else if (cat === CategoryType.GRI_2) {
          setGRI2TableData(questions);
        } else if (cat === 'BRSR') {
          setBRSRTableData(questions);
        }
      })
      .catch((error) => { });
  };

  const editQuestion = (ques, dId) => {
    setEditedQuestion({ question: ques, disclosureId: dId });
  };

  const isUniversalStandardCategory = (cat) => {
    return cat === CategoryType.GRI_1
      || cat === CategoryType.GRI_2
      || cat === CategoryType.GRI_3
      || cat === 'BRSR';
  };

  const canReorderTopics = (categoryType) =>
    hasConfigUpdatePermission() && !isFinalizeInProgress && !isUniversalStandardCategory(categoryType);

  const setCategoryTopics = (categoryType, topics) => {
    switch (categoryType) {
      case 'SOCIAL': setSocialTableData([...topics]); break;
      case 'ENVIRONMENTAL': setEnvironmentTableData([...topics]); break;
      case 'GOVERNANCE': setGovernanceTableData([...topics]); break;
      default: break;
    }
    setData(prev => [
      ...prev.filter(t => t.categoryType !== categoryType),
      ...topics,
    ]);
  };

  const reorderTopicsLocally = (topics, draggedId, afterTopicId) => {
    const moved = topics.find(t => t.id === draggedId);
    if (!moved) return topics;

    const updated = topics.filter(t => t.id !== draggedId);
    const prevIndex = updated.findIndex(t => t.id === afterTopicId);
    updated.splice(prevIndex + 1, 0, moved);
    return updated;
  };

  useEffect(() => {
    const resetDragHandle = () => setIsDragHandleActive(false);
    window.addEventListener("mouseup", resetDragHandle);
    return () => window.removeEventListener("mouseup", resetDragHandle);
  }, []);

  const onTopicDragHandleMouseDown = () => {
    setIsDragHandleActive(true);
  };

  const onTopicDragStart = (topic) => {
    setDraggedTopic(topic);
  };

  const onTopicDragOver = (e, topicId, categoryType) => {
    e.preventDefault();
    setDragOverTopicId(topicId);
    setDragOverCategory(categoryType);
  };

  const onTopicDragEnd = (categoryType) => {
    setIsDragHandleActive(false);

    if (
      !draggedTopic
      || !dragOverTopicId
      || draggedTopic.id === dragOverTopicId
      || draggedTopic.categoryType !== categoryType
      || dragOverCategory !== categoryType
    ) {
      setDraggedTopic(null);
      setDragOverTopicId(null);
      setDragOverCategory(null);
      return;
    }

    const topics = getTableGrouped({ categoryType });
    const reordered = reorderTopicsLocally(topics, draggedTopic.id, dragOverTopicId);
    setCategoryTopics(categoryType, reordered);

    StandardService.reorderTopic(std_id, draggedTopic.id, { movedToId: dragOverTopicId })
      .finally(() => getTopics(std_id));

    setDraggedTopic(null);
    setDragOverTopicId(null);
    setDragOverCategory(null);
  };

  const isTopicDragTarget = (item, categoryType) =>
    canReorderTopics(categoryType)
    && dragOverTopicId === item.id
    && draggedTopic?.id !== item.id
    && dragOverCategory === categoryType;

  const isTopicDragging = (item, categoryType) =>
    canReorderTopics(categoryType) && draggedTopic?.id === item.id;

  const canManageTopicExportImport = () =>
    hasConfigUpdatePermission() && !isFinalizeInProgress && onSelectedTopicIdsChange;

  const getCategoryTopicIds = (categoryType) =>
    (getTableGrouped({ categoryType }) || []).map(topic => topic.id);

  const areAllCategoryTopicsSelected = (categoryType) => {
    const ids = getCategoryTopicIds(categoryType);
    return ids.length > 0 && ids.every(id => selectedTopicIds.includes(id));
  };

  const toggleTopicSelection = (topicId) => {
    if (!onSelectedTopicIdsChange) return;
    onSelectedTopicIdsChange(
      selectedTopicIds.includes(topicId)
        ? selectedTopicIds.filter(id => id !== topicId)
        : [...selectedTopicIds, topicId]
    );
  };

  const toggleSelectAllCategory = (categoryType) => {
    if (!onSelectedTopicIdsChange) return;
    const ids = getCategoryTopicIds(categoryType);
    if (areAllCategoryTopicsSelected(categoryType)) {
      onSelectedTopicIdsChange(selectedTopicIds.filter(id => !ids.includes(id)));
    } else {
      onSelectedTopicIdsChange([...new Set([...selectedTopicIds, ...ids])]);
    }
  };

  return (
    <>
      {categoryData?.length > 0 && categoryData?.map((mainitem, catIndex) => (
        <div className="Topics" key={`cat-${catIndex}`} id={`cat-${catIndex}`}>
          <>
            <div className="card StandardsSub_Topics_Card">
              <div className="card-body p-0">
                <div className="SST_CardBox">
                  <div className="SST_CardBox_head">
                    <div className="expand_RswBox 1">
                      <BiChevronDown
                        onClick={(e) => handleExpand(mainitem.categoryType)}
                        aria-controls="example-collapse-text"
                      ></BiChevronDown>
                    </div>
                    <div className="SST_view_data d-flex">
                      <h6 className="mb-0 me-2" >{getCategoryName(mainitem).toUpperCase()}</h6>
                      <span><strong>{getCategoryCount(mainitem)}</strong> <BiGitMerge /></span>
                    </div>
                  </div>
                  <Collapse in={shown[mainitem.categoryType]}>
                    <div className="Sub_Top_ViewCard">
                      {
                        isUniversalStandardCategory(mainitem.categoryType) &&
                        <button className="btn btn-primary mb-2" hidden={!hasConfigUpdatePermission() || isFinalizeInProgress} onClick={() => {
                          if (isFinalizeInProgress) return;
                          editQuestion({ id: 0 }, mainitem.disclosure?.id)
                        }} disabled={isFinalizeInProgress}><BiPlus /> {t("Question.label")}
                        </button>
                      }
                      {
                        !isUniversalStandardCategory(mainitem.categoryType) &&
                        getTableData(mainitem)?.length > 0 &&
                        canManageTopicExportImport() &&
                        <div className="row m-0 mb-2 align-items-center topics-select-all-row">
                          <div className="col-auto p-1 d-flex align-items-center">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                              id={`select-all-topics-${mainitem.categoryType}`}
                              checked={areAllCategoryTopicsSelected(mainitem.categoryType)}
                              onChange={() => toggleSelectAllCategory(mainitem.categoryType)}
                            />
                            <label className="form-check-label mb-0" htmlFor={`select-all-topics-${mainitem.categoryType}`}>
                              {t("SelectAll.label")}
                            </label>
                          </div>

                        </div>
                      }
                      {getTableData(mainitem)?.map((item) => (
                        <div className="row m-0" key={item.id}>
                          <div className="col-lg-8 p-0">
                            <div
                              className={`card Sub_Top_ViewCard_inner${isTopicDragTarget(item, mainitem.categoryType) ? ' standards-drop-target' : ''}${isTopicDragging(item, mainitem.categoryType) ? ' opacity-50' : ''}`}
                              key={item.id}
                              draggable={canReorderTopics(mainitem.categoryType) && isDragHandleActive}
                              onDragStart={() => onTopicDragStart(item)}
                              onDragOver={(e) => canReorderTopics(mainitem.categoryType) && onTopicDragOver(e, item.id, mainitem.categoryType)}
                              onDragEnd={() => onTopicDragEnd(mainitem.categoryType)}
                            >
                              <div className="card-body p-2">
                                <div className="topics-item-header">
                                  <div
                                    className={`row m-0 pe-5 align-items-center${isUniversalStandardCategory(mainitem.categoryType) && item.children?.length > 0 ? ' mb-2' : ''}`}
                                  >
                                    <div
                                      className="col-auto p-1 topic-drag-handle 1"
                                      onMouseDown={() => canReorderTopics(mainitem.categoryType) && onTopicDragHandleMouseDown()}
                                    >
                                      <BiGridVertical />
                                    </div>

                                    {
                                      !isUniversalStandardCategory(mainitem.categoryType) &&
                                      canManageTopicExportImport() &&
                                      <div className="col-auto p-1 d-flex align-items-center">
                                        <input
                                          className="form-check-input m-0"
                                          type="checkbox"
                                          checked={selectedTopicIds.includes(item.id)}
                                          onChange={() => toggleTopicSelection(item.id)}
                                          onClick={(e) => e.stopPropagation()}
                                        />
                                      </div>
                                    }
                                    <div
                                      className={`${!isUniversalStandardCategory(mainitem.categoryType) && canManageTopicExportImport() ? 'col' : 'col-lg-10 col-md-10 col-10'} p-1`}
                                    >
                                      <h6 className="mb-0 me-2">
                                        {isUniversalStandardCategory(mainitem.categoryType) ? `${item.code}: ` : ''}
                                        {item.name}
                                      </h6>
                                    </div>
                                    {
                                      !isUniversalStandardCategory(mainitem.categoryType) &&
                                      <div className="col-auto p-1">
                                        <h6 className="mb-0 cursor">
                                          <span className="gotoMetric_countbox" onClick={() => gotoMetric(item.name, item.id, mainitem.categoryType)}>
                                            {item.childrenCount ? item.childrenCount : 0}
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={Utils.renderTooltip(
                                                t("ViewMetrics.label")
                                              )}
                                            >
                                              <span className="ms-1">
                                                <BiGitMerge
                                                  onClick={() => gotoMetric(item.name, item.id, mainitem.categoryType)}
                                                />
                                              </span>
                                            </OverlayTrigger>
                                          </span>
                                        </h6>
                                      </div>
                                    }
                                  </div>
                                  <div className="edit_btn-absolute">
                                    {
                                      item.mandatory === true ? (
                                        ""
                                      ) : (
                                        <Dropdown hidden={!hasConfigUpdatePermission() || isFinalizeInProgress}>
                                          <Dropdown.Toggle variant="blank_outline" id="dropdown-basic" disabled={isFinalizeInProgress}>
                                            <BiDotsHorizontalRounded />
                                          </Dropdown.Toggle>
                                          <Dropdown.Menu>
                                            <Dropdown.Item
                                              href="#"
                                              onClick={() => {
                                                if (isFinalizeInProgress) return;
                                                if (isUniversalStandardCategory(mainitem.categoryType)) {
                                                  editQuestion(item, mainitem.disclosure?.id);
                                                } else {
                                                  editTopic(item);
                                                }
                                              }}
                                              disabled={isFinalizeInProgress} >
                                              <BiPencil className="me-2" />
                                              {t("Edit.label")}
                                            </Dropdown.Item>
                                            {
                                              !isUniversalStandardCategory(mainitem.categoryType) &&
                                              <Dropdown.Item
                                                onClick={() => {
                                                  if (isFinalizeInProgress) return;
                                                  deleteTopic(item);
                                                }}
                                                disabled={isFinalizeInProgress} >
                                                <BiTrash className="me-2" />
                                                {t("Delete.label")}
                                              </Dropdown.Item>
                                            }
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      )}
                                  </div>
                                </div>
                                {
                                  isUniversalStandardCategory(mainitem.categoryType) &&
                                  item.children
                                    ?.sort((a, b) => a.sortOrder - b.sortOrder)
                                    ?.map((child, childIndex) => {
                                      return (
                                        <div
                                          className="card Sub_Top_ViewCard_inner SSTView_card"
                                          key={`childQues-${childIndex}`}
                                          id={`childQues-${childIndex}`}
                                        >
                                          <div className="card-body p-2">
                                            <h6 className="mb-0 me-2">{`${child.code}: ${child.name}`}</h6>
                                          </div>
                                        </div>
                                      );
                                    })
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                      {
                        !isUniversalStandardCategory(mainitem.categoryType) &&
                        <div className="col-lg-12 p-1">
                          <button
                            className="btn btn-primary me-2"
                            hidden={!hasConfigUpdatePermission() || isFinalizeInProgress}
                            onClick={() => {
                              if (isFinalizeInProgress) return;
                              setEditTopicId(null);
                              handleShow(mainitem.categoryType)
                            }}
                            disabled={isFinalizeInProgress}
                          >
                            <BiPlus className="me-2"> </BiPlus>
                            {t("Topic.label")}
                          </button>
                        </div>
                      }
                    </div>
                  </Collapse>
                </div>
              </div>
            </div>
          </>
        </div >))
      }

      <Modal size="lg" show={show} onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title as="h5">{editTopicId ? t("EditTopic.label") : t("AddTopic.label")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddTopic
            stdId={std_id}
            handleDiscard={handleClose}
            editTopicId={editTopicId}
            handleSave={handleAfterSave}
            currentcategory={localStorage.getItem('categoryName')}
          />
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary">Understood</Button>
        </Modal.Footer> */}

      </Modal>

      {
        deleteId && <ConfirmDialog
          open={confirmOpen}
          setOpen={setConfirmOpen}
          onConfirm={deletConfirm}                        >
          <div className='text-center'>{t("ConfirmDelete.label")}</div>
        </ConfirmDialog>
      }

      {
        editedQuestion?.question?.id >= 0 &&
        <GDQuestionFormPopup disclosureId={editedQuestion?.disclosureId}
          question={editedQuestion.question}
          saveCallback={() => {
            setEditedQuestion(null);
            let cat;
            if (shown[CategoryType.GRI_1] === true) {
              cat = CategoryType.GRI_1;
            }
            if (shown[CategoryType.GRI_2] === true) {
              cat = CategoryType.GRI_2;
            }
            if (shown[CategoryType.GRI_3] === true) {
              cat = CategoryType.GRI_3;
            }
            if (shown['BRSR'] === true) {
              cat = 'BRSR';
            }
            loadDisclosureQuestions(cat);
          }} />
      }

    </>
  );
}
export default withTranslation()(Topics);
